import { api } from './client'

/** C-18 (REQ-288-001): client di `RetentionController`. Solo Admin, dietro il flag `privacy.conservazione`. */
export const RETENTION_FLAG = 'privacy.conservazione'
/** R3-31: esecuzione vera (anonimizzazione dei lead scaduti), dietro conferma scritta e nota. */
export const RETENTION_EXEC_FLAG = 'privacy.conservazione_esecuzione'
/** Categorie che l'esecuzione sa trattare oggi; le altre restano a rapporto. */
export const RETENTION_EXECUTABLE = ['leads_non_convertiti']

export type RetentionAction = 'Anonimizza' | 'Cancella'

export const RETENTION_CATEGORY_LABELS: Record<string, string> = {
  leads_non_convertiti: 'Lead non convertiti',
  documenti: 'Documenti',
  log: 'Registro di audit',
  import: 'Lotti di import',
  export: 'Richieste di export',
  backup: 'Backup',
}

export interface RetentionPolicy {
  category: string
  days: number
  action: RetentionAction
}

export interface RetentionReportLine {
  category: string
  days: number | null
  action: RetentionAction | null
  cutoff: string | null
  candidates: number | null
  note: string
}

export interface RetentionExecutionResult {
  category: string
  action: string
  days: number
  cutoff: string
  candidates: number
  processed: number
  batches: number
  note: string
}

export const retentionApi = {
  list: () => api<{ categories: string[]; items: RetentionPolicy[] }>('/api/retention-policies'),
  save: (category: string, days: number, action: RetentionAction) =>
    api<RetentionPolicy>(`/api/retention-policies/${category}`, { method: 'PUT', body: JSON.stringify({ days, action }) }),
  remove: (category: string) => api<void>(`/api/retention-policies/${category}`, { method: 'DELETE' }),
  report: () => api<{ executes: boolean; items: RetentionReportLine[] }>('/api/retention-policies/report'),
  execute: (category: string, confirmation: string, note: string) =>
    api<{ executes: boolean; result: RetentionExecutionResult; note: string }>(
      `/api/retention-policies/${category}/execute`, { method: 'POST', body: JSON.stringify({ confirmation, note }) }),
}
